import React from 'react';

import { SOCardSkeleton } from '../so-card-skeleton';

import { useSOListSkeletonLang } from './hooks';

import makeClasses from './SOListSkeleton.style';

const SKELETON_COUNT = 4;

export function SOListSkeleton() {
  const _classes = makeClasses();
  const lang = useSOListSkeletonLang();

  return (
    <ul className={_classes.list} aria-label={lang.loadingLabel}>
      {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
        <li key={index} className={_classes.listItem}>
          <SOCardSkeleton />
        </li>
      ))}
    </ul>
  );
}
